import defaultTheme from './defaultTheme';
const syfMastercardTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#004ebc', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#004ebc', background: '#004ebc' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#004ebc' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#004ebc', border: '#004ebc', background: '#004ebc' }), field: {
        focus: '#004ebc',
        label: '#004ebc',
        icon: '#004ebc',
    } });
export default syfMastercardTheme;
